/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CrowdstrikeVlrOrgSecretSpec { 
    cid: string;
    api_key_id: string;
    api_key: string;
    authorization_timestamp: Date;
}

